import { useState } from 'react';
import type { BusinessProduct } from '@recargas-dominicanas/core/types';
import { TextField, Image } from '@recargas-dominicanas/core/components';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { Modal } from '../../../../components/modal/modal.component';
import { style } from './edit-product-modal.module.css';
import { BusinessApi } from '@recargas-dominicanas/core/adminApi';
import { BusinessStore } from '../../../../store/businessStore';

interface Props {
  open: boolean;
  businessProduct: BusinessProduct;
  onClose: () => void;
}

export function EditProductModal(props: Props) {

  const {
    open,
    businessProduct,
    onClose
  } = props;

  const [error, setError] = useState<string>();
  
  const form = useForm({
    profit: { value: businessProduct.profit.toString() }
  }, [open]);

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      await BusinessApi.updateProduct(businessProduct.businessId, businessProduct.id, {
        profit: parseFloat(form.profit.value)
      });

      await BusinessStore.fetchProducts(businessProduct.businessId);

      handleClose();

    } catch {

      setError('Error actualizando producto');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Editar producto'
      style={style.modal}
      secondaryButton='Guardar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <div className={style.product}>
        <div className={style.productLabel}>Producto</div>
        <div className={style.productContent}>
          <Image className={style.productImage} src={businessProduct.product.image}/>
          <div className={style.productName}>{businessProduct.product.name}</div>
        </div>
      </div>
      <TextField 
        style={style.textField}
        label='Beneficio'
        type='number'
        value={form.profit.value}
        error={form.profit.error}
        onChange={form.profit.onChange}
        onBlur={form.profit.onBlur}/>
    </Modal>
  );
}
